export function EllipsisSvg() {
  return (
    <svg fill="none" height="20" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M14.4453 4.66699C14.4453 5.77156 13.5499 6.66699 12.4453 6.66699C11.3407 6.66699 10.4453 5.77156 10.4453 4.66699C10.4453 3.56242 11.3407 2.66699 12.4453 2.66699C13.5499 2.66699 14.4453 3.56242 14.4453 4.66699ZM14.4453 12.0559C14.4453 13.1605 13.5499 14.0559 12.4453 14.0559C11.3407 14.0559 10.4453 13.1605 10.4453 12.0559C10.4453 10.9513 11.3407 10.0559 12.4453 10.0559C13.5499 10.0559 14.4453 10.9513 14.4453 12.0559ZM12.4453 21.4448C13.5499 21.4448 14.4453 20.5494 14.4453 19.4448C14.4453 18.3402 13.5499 17.4448 12.4453 17.4448C11.3407 17.4448 10.4453 18.3402 10.4453 19.4448C10.4453 20.5494 11.3407 21.4448 12.4453 21.4448Z"
        fill="#F9F9F9"
        fillRule="evenodd"
      />
    </svg>
  );
}
